import { useQuery } from 'react-query'
import { CompensationResponse, fetchCompensation, PractitionerType } from '../../api/salaryCalculation'

type UseGetCompensationProps = {
  practitionerReferenceId: string
  date: string
  type: PractitionerType
  initialCompensation: boolean
}

const useGetCompensation = ({ practitionerReferenceId, date, type, initialCompensation }: UseGetCompensationProps) => {
  const queryKey = [`compensation-${practitionerReferenceId}-${date}`]
  return useQuery<CompensationResponse>(
    queryKey,
    () => fetchCompensation(practitionerReferenceId, date, type, initialCompensation),
    {
      enabled: !!practitionerReferenceId && !!date,
      retry: 1,
    }
  )
}

export default useGetCompensation
